var path = '/common/formly/wrappers/tpl/settings-panel.html';
var html = "<div class=\"settings-panel form-group\"> <uib-accordion close-others=oneAtATime> <div uib-accordion-group ng-class=\"('panel-' + (options.templateOptions.panelContext || 'default') + ' ' + (options.templateOptions.panelClass))\" heading={{options.templateOptions.label}} is-open=options.templateOptions.isOpen> <div class=panel-description ng-if=options.templateOptions.description>{{options.templateOptions.description}}</div> <formly-transclude></formly-transclude> </div> </uib-accordion> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/common/formly/wrappers/tpl/settings-panel.html
// module id = 206
// module chunks = 0 1 2 3 5 6